import React, {createContext, useContext} from 'react';
import * as Yup from 'yup';
import {FormikProvider, useFormik} from 'formik';
import {useDispatch} from "react-redux";
import * as actions from '../_redux/transfersByAgentActions';
import {useTransfersByAgentContext} from "./TransfersByAgentContext";

const PopupSplitLinesContext = createContext({});

export const usePopupSplitLinesContext = () => useContext(PopupSplitLinesContext);

export const PopupSplitLinesContextProvider = ({children, amount}) => {
  const dispatch = useDispatch();
  const {getTransfersByAgent, agentId} = useTransfersByAgentContext();
  const formik = useFormik({
    initialValues: {
      amounts: [{
        amount: amount || 0
      }]
    },
    validateOnMount: true,
    validationSchema: Yup.object().shape({
      amounts: Yup.array().min(2),
    }),
    onSubmit: () => {
    },
    enableReinitialize: true
  });

  const handleSplit = (receiptLineId, firstAmount) => {
    if (receiptLineId) {
      const amounts = formik.values.amounts
        .map((item, index) => {
          if (index !== 0) {
            return item.amount ? parseFloat(item.amount) : 0;
          }
        })
        .filter(Boolean);
      const result = [firstAmount, ...amounts];
      dispatch(actions.splitReceiptLines(receiptLineId, result, agentId));
      formik.resetForm();
      getTransfersByAgent();
    }
  };

  return (
    <PopupSplitLinesContext.Provider
      value={{formik, totalAmount: amount, handleSplit}}
    >
      <FormikProvider value={formik}>
        {children}
      </FormikProvider>
    </PopupSplitLinesContext.Provider>
  );
};